import { RoleName } from 'api/services';

export const checkRequiredScopes = (
  requiredScopes: RoleName[],
  availableScopes: RoleName[],
): boolean => requiredScopes.every((scope) => availableScopes.includes(scope));
